import { Navigation, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutRecoveryEntries } from "./autogen/AutogenLayoutRecoveryEntries";

export class RecoveryEntries extends AutogenLayoutRecoveryEntries {
    labelTotalOnClick() {
        const urlParams: string[] = [];
        urlParams.push("recoveryEntries=true");
        Navigation.navigateTo("lme/datafusion/RecoveryList" + UrlUtil.buildQueryString(urlParams));
    }

    afterExecution() {
        const amount: number = this.labelTotalCount.text as unknown as number;
        if (amount < 100) {
            this.labelTotalCount.color = "primary";
        } else if (amount >= 100 && amount < 500) {
            this.labelTotalCount.color = "warning";
        } else {
            this.labelTotalCount.color = "error";
        }
    }
}